/* eslint-disable camelcase,new-cap */
import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'
let graphqlClient = null

export const state = {
  objects: {},
  unassignedObjects: {},
  toReassignObjects: {},
  currentCollection: {},
  binsPickup: {},
}

export const getters = {}

export const mutations = {
  SET_COLLECTIONS(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.objects = {
      ...updatedObjects,
    }
  },
  SET_BINS_PICKUP(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.binsPickup = {
      ...updatedObjects,
    }
  },
  SET_UNASSIGNED_COLLECTIONS(state, unassignedObjects) {
    state.unassignedObjects = unassignedObjects
  },
  SET_COLLECTIONS_TO_REASSIGN(state, toReassignObjects) {
    state.toReassignObjects = toReassignObjects
  },
  SET_COLLECTION(state, objects) {
    state.currentCollection = objects
  },
}

export const actions = {
  init({ commit, rootState }) {
    // Initialise the GraphQL client
    graphqlClient = createGraphQLClient(rootState)
  },

  async getCollections({ commit }, { dateStart, dateEnd } = {}) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query getCollectionsByDate($dateStart: String!, $dateEnd: String!){
              collectionsByDate (start_date: $dateStart, end_date: $dateEnd){
                  id
                  client {
                    id
                    client_name
                  }
                  site {
                    id
                    address
                    suburb
                    postcode
                    phone
                    mobile
                    contact_name
                    trading_name
                  }
                  binsToCollect {
                    id
                    bin {
                      id
                      description
                      name
                      capacity
                      itemcode
                      price
                    }
                  }
                  driver_id
                  service_id
                  service_type{
                    id,
                    name,
                    description,
                  }
                  expected_collection_time
                  created_by
                  actual_amount_collected
                  collection_date
                  collection_time
                  collection_instance_exception {
                    id
                    description
                    status
                    photos {
                      id
                      url
                    }
                  }
                  completed
                  processed
                  runsheet {
                    id
                    vehicle {
                      id
                      number_plate
                    }
                  }
                  notes
                  created_at
                  updated_at
                  deleted_at
                }
            }
          `,
          variables: { dateStart: dateStart.toString(), dateEnd: dateEnd.toString() },
        })
        .then(response => {
          return response.data.collectionsByDate
          // commit('SET_COLLECTIONS', response.data.collectionsByDate)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async getCollectionById({ commit }, { id } = {}) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query getCollectionById($cid: ID!) {
              collectionById(id: $cid) {
                id
                client {
                  id
                  client_name
                }
                site {
                  id
                  address
                  suburb
                  postcode
                  phone
                  mobile
                }
                binsToCollect {
                  id
                  bin {
                    id
                    description
                    name
                    capacity
                    itemcode
                    price
                  }
                }
                driver_id
                service_id
                expected_collection_time
                created_by
                collection_date
                collection_time
                collection_instance_exception {
                  id
                  description
                  status
                  photos {
                    id
                    url
                  }
                }
                lat
                lon
                order
                completed
                created_at
                updated_at
                deleted_at
              }
            }
          `,
          variables: { cid: id },
        })
        .then(response => {
          commit('SET_COLLECTION', response.data.collectionById)
          return response.data.collectionById
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async getCollectionsByClientID({ commit }, { ClientId } = {}) {
    try {
      const response = await graphqlClient.query({
        query: gql`
          query getCollectionsByClientId($ClientId: Int!) {
            collectionsByClientId(client_id: $ClientId) {
              id
              client {
                id
                client_name
              }
              site {
                id
                address
                suburb
                postcode
                phone
                mobile
              }
              binsToCollect {
                id
                bin {
                  id
                  description
                  name
                  
                  itemcode
                  price
                }
              }
              driver_id
              service_id
              expected_collection_time
              created_by
              collection_date
              collection_time
              collection_instance_exception {
                id
                description
                status
                photos {
                  id
                  url
                }
              }
              lat
              lon
              order
              completed
              created_at
              updated_at
              deleted_at
            }
          }
        `,
        variables: { ClientId: ClientId },
      })
      commit('SET_COLLECTION', response.data.collectionsByClientId)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async getCollectionsByServiceId({ commit }, { ServiceId } = {}) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query getCollectionsByServiceId($ServiceId: ID!) {
              collectionsByServiceId(service_id: $ServiceId) {
                id
                client {
                  id
                  client_name
                }
                service {
                  id
                  service_bins {
                    id
                    charge_per_tonne
                    charge_per_litre
                  }
                }
                binsToCollect {
                  id
                  bin {
                    id
                    description
                    name
                    capacity
                    itemcode
                    price
                  }
                }
                actual_amount_collected
                site {
                  id
                  address
                  suburb
                  postcode
                  phone
                  mobile
                }
                driver_id
                service_id
                expected_collection_time
                created_by
                collection_date
                collection_time
                collection_instance_exception {
                  id
                  description
                  status
                  photos {
                    id
                    url
                  }
                }
                lat
                lon
                order
                completed
                created_at
                updated_at
                deleted_at
              }
            }
          `,
          variables: { ServiceId: ServiceId },
        })
        .then(response => {
          commit('SET_COLLECTIONS', response.data.collectionsByServiceId)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async getBinPickupsByCollectionId({ commit }, { colId } = {}) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query getBinPickupsByCollectionId($CollectionId: Int) {
              binpickupsByCollectionId(collection_id: $CollectionId) {
                id
                pickup_number
                time_collected
                weight_collected
                created_at
                updated_at
                deleted_at
              }
            }
          `,
          variables: { CollectionId: colId },
        })
        .then(response => {
          commit('SET_BINS_PICKUP', response.data.binpickupsByCollectionId)
          return response.data.binpickupsByCollectionId
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async createCollection(
    { commit, dispatch },
    {
      service_id,
      expected_collection_time,
      created_by,
      collection_date,
      collection_time,
      order,
      completed,
      processed,
      runsheetId,
      bins,
      siteId
    } = {}
  ) {
    try {
      return await graphqlClient
        .mutate({
          mutation: gql`
            mutation CreateCollection(
              $Service_id: Int
              $ECT: String
              $Created_by: Int
              $Collection_date: String
              $Collection_time: String
              $Order: Int
              $Completed: Boolean
              $Processed: Boolean
              $RunsheetId: ID
              $Bins: [Int]
              $SiteId: Int
            ) {
              createCollection(
                collection: {
                  service_id: $Service_id
                  expected_collection_time: $ECT
                  created_by: $Created_by
                  collection_date: $Collection_date
                  collection_time: $Collection_time
                  order: $Order
                  completed: $Completed
                  processed: $Processed
                  runsheet_id: $RunsheetId
                  bins: $Bins
                  site_id: $SiteId
                }
              ) {
                id
              }
            }
          `,
          variables: {
            Service_id: service_id,
            ECT: expected_collection_time,
            Created_by: created_by,
            Collection_date: collection_date,
            Collection_time: collection_time,
            Order: order,
            Completed: completed,
            Processed: processed,
            RunsheetId: runsheetId,
            Bins: bins,
            SiteId: siteId,
          },
        })
        .then(response => {
          return response
          // dispatch('getCollectionsByServiceId')
        })
    } catch (ex) {
      console.error(ex)

      throw ex
    }
  },

  async updateCollection(
    { commit },
    {
      collectionId,
      service_id,
      expected_collection_time,
      created_by,
      collection_date,
    } = {}
  ) {
    try {
      return await graphqlClient
        .mutate({
          mutation: gql`
            mutation UpdateCollection(
              $cid: Int
              $Service_id: Int
              $ECT: String
              $Created_by: Int
              $Collection_date: String
            ) {
              updateCollection(
                id: $cid
                collection: {
                  service_id: $Service_id
                  expected_collection_time: $ECT
                  created_by: $Created_by
                  collection_date: $Collection_date
                }
              ) {
                id
              }
            }
          `,
          variables: {
            cid: collectionId,
            Service_id: service_id,
            ECT: expected_collection_time,
            Created_by: created_by,
            Collection_date: collection_date
          },
        })
        .then(response => {
          // commit('SET_COLLECTIONS', response.data.updateCollection)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async updateCurrentCollection(
    { commit },
    {
      collectionId,
      completed,
      actual_amount_collected,
    } = {}
  ) {
    try {
      return await graphqlClient
        .mutate({
          mutation: gql`
            mutation UpdateCollection(
              $cid: Int
              $Completed: Boolean
              $Actual_amount_collected: [Float]
            ) {
              updateCollection(
                id: $cid
                collection: {
                  completed: $Completed
                  actual_amount_collected: $Actual_amount_collected
                }
              ) {
                id
              }
            }
          `,
          variables: {
            cid: collectionId,
            Completed: completed,
            Actual_amount_collected: actual_amount_collected,
          },
        })
        .then(response => {
          return response
          // commit('SET_COLLECTIONS', response.data.updateCollection)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async voidCollection(
    { commit },
    {
      collectionId,
      completed,
      chargeDescription,
    } = {}
  ) {
    try {
      return await graphqlClient
        .mutate({
          mutation: gql`
            mutation UpdateCollection(
              $cid: Int
              $Completed: Boolean
              $chargeDescription: String
            ) {
              updateCollection(
                id: $cid
                collection: {
                  completed: $Completed,
                  charge_description: $chargeDescription
                }
              ) {
                id
              }
            }
          `,
          variables: {
            cid: collectionId,
            Completed: completed,
            chargeDescription: chargeDescription,
          },
        })
        .then(response => {
          return response
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async updateCollectionCharge(
    { commit },
    { collectionId, reason, amount } = {}
  ) {
    try {
      await graphqlClient
        .mutate({
          mutation: gql`
            mutation updateCollectionCharge(
              $cid: Int
              $Amount: Int
              $Reason: String
            ) {
              updateCollection(
                id: $cid
                collection: { charge_description: $Reason, cost: $Amount }
              ) {
                id
              }
            }
          `,
          variables: { cid: collectionId, Reason: reason, Amount: amount },
        })
        .then(response => {
          // commit('SET_COLLECTIONS', response.data.updateCollection)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async updateUnassignedCollection(
    { commit },
    { collectionId, vroom_id } = {}
  ) {
    try {
      let status = true
      await graphqlClient
        .mutate({
          mutation: gql`
            mutation updateUnassignedCollection(
              $cid: ID
              $vroomId: ID
              $corrected: Boolean
            ) {
              updateUnassignedCollection(
                collection_id: $cid
                vroom_schedule_id: $vroomId
                corrected: $corrected
              ) {
                collection_id
              }
            }
          `,
          variables: {
            cid: collectionId,
            vroomId: vroom_id,
            corrected: status,
          },
        })
        .then(response => {
          // commit('SET_COLLECTIONS', response.data.updateCollection)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async setCollectionRunSheet({ commit }, { collectionId, runsheetId } = {}) {
    try {
      await graphqlClient
        .mutate({
          mutation: gql`
            mutation UpdateCollection($cid: Int, $RunsheetId: ID) {
              updateCollection(
                id: $cid
                collection: { runsheet_id: $RunsheetId }
              ) {
                id
              }
            }
          `,
          variables: { cid: collectionId, RunsheetId: runsheetId },
        })
        .then(response => {
          commit('SET_COLLECTIONS', response.data.updateCollection)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async moveCollectionsToRunSheet(
    { commit },
    { collectionIds, runsheetId } = {}
  ) {
    try {
      await graphqlClient
        .mutate({
          mutation: gql`
            mutation moveCollectionsToRunSheet($cid: [Int], $RunsheetId: ID) {
              moveCollectionsToRunsheet(
                collection_ids: $cid
                runsheet_id: $RunsheetId
              ) {
                id
              }
            }
          `,
          variables: { cid: collectionIds, RunsheetId: runsheetId },
        })
        .then(response => {
          // commit('SET_COLLECTIONS', response.data.updateCollection)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async deleteCollection({ commit }, { id } = {}) {
    try {
      await graphqlClient
        .mutate({
          mutation: gql`
            mutation DeleteCollection($cid: Int!) {
              deleteCollection(id: $cid) {
                id
              }
            }
          `,
          variables: { cid: id },
        })
        .then(response => {
          commit('SET_COLLECTION', response.data.deleteCollection)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async notifyDriverWithCollectionData({ commit }, { channel, message } = {}) {
    try {
      return await graphqlClient
        .mutate({
          mutation: gql`
            mutation broadcastMutation($Channel: String, $Message: String) {
              broadcast(channel: $Channel, message: $Message)
            }
          `,
          variables: { Channel: channel, Message: message },
        })
        .then(response => {
          return response
          // commit('SET_COLLECTION', response.data.deleteCollection)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async getUnassignedCollections({ commit }) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query getUnassignedCollectionData {
              unassignedCollectionsNotCorrected {
                description
                corrected
                vroom_schedule_id
                collection {
                  id
                  client {
                    id
                    client_name
                  }
                  binsToCollect {
                    id
                    bin {
                      id
                      description
                      name
                      capacity
                      itemcode
                      price
                    }
                  }
                  expected_collection_time
                  collection_date
                  site {
                    id
                    address
                    suburb
                    postcode
                  }
                  service {
                    id
                    service_title
                  }
                  notes
                }
                created_at
                updated_at
                deleted_at
              }
            }
          `,
        })
        .then(response => {
          commit(
            'SET_UNASSIGNED_COLLECTIONS',
            response.data.unassignedCollectionsNotCorrected
          )
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async getCollectionsToReAssign({ commit }) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query getCollectionsToReAssign {
              collections(runsheet_unassigned: true) {
                id
                client {
                  id
                  client_name
                }
                expected_collection_time
                binsToCollect {
                  id
                  bin {
                    id
                    description
                    name
                    capacity
                    itemcode
                    price
                  }
                }
                collection_date
                site {
                  id
                  address
                  suburb
                  postcode
                }
                service_type {
                  id
                  name
                  description
                }
                processed
                completed
                runsheet_id
                notes
                created_at
                updated_at
                deleted_at
              }
            }
          `,
        })
        .then(response => {
          commit('SET_COLLECTIONS_TO_REASSIGN', response.data.collections)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
}
